import { ChangePasswordForm } from '@/forms/ChangePasswordForm/ChangePasswordForm';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

export function PasswordSettingsTab() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-8 max-w-2xl">
      <ChangePasswordForm
        action="/me"
        onSuccess={() => {
          toast.success(t('user.settings.changePassword.submit.success'));
        }}
      />
    </div>
  );
}
